import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading01, typeBody02, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery, maxWidth, gutter } from '../../theme/metrics'

import { button } from '../../theme/core';

import { StyledButtons } from '../../theme/components';

export const Container = styled.section`
	${grid}
	margin: 0 auto;
	max-width: ${maxWidth()};
`

export const Inner = styled.div`
	${row({medium:{reverse:true}})}
`

export const ImageContainer = styled.div`
	${props => column({medium:{span:7},large:{span:7}},{direction:props.theme.direction,reverse:true})}
	display: flex;
	flex-direction: column;

	position: relative;
	top: ${unit(-8)};
	margin-bottom: ${unit(-8)};

	${mediaQuery[SIZE.medium]}{
		top: 0;
		margin-bottom: 0;
	}

	&:after{
		content: url(/images/squiggle-1.svg);
		width:176px;
		height:176px;
		position: absolute;
		display: block;
		bottom: 0;
		left: 0;
		transform: translate(0,50%);
	}
`

export const ImageInner = styled.div`
	flex: 1;
	overflow: hidden;
	margin-right: ${margin(SIZE.small,{multiplier:-1})};

	${mediaQuery[SIZE.medium]}{
		margin-left: ${margin(SIZE.medium,{multiplier:-1})};
		margin-right: ${gutter(SIZE.medium,{multiplier:-1})};
	}

	${mediaQuery[SIZE.large]}{
		margin-left: ${margin(SIZE.large,{multiplier:-1})};
		margin-right: ${gutter(SIZE.large,{multiplier:-1})};
	}

	${mediaQuery[SIZE.max]}{
		margin-left: ${margin(SIZE.max,{multiplier:-1})};
		margin-right: ${gutter(SIZE.max,{multiplier:-1})};
	}
`

export const Image = styled.img`
	width: 100%;
	height: auto;
	display: block;
	

	${mediaQuery[SIZE.medium]}{
		height: 100%;
		object-fit: cover;
		position: absolute;

		// IE 10,11 hack
		@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
			height: 100%;
			width: auto;
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
		}
	}
`

export const ContentContainer = styled.div`
	${props => column({medium:{span:7,before:-2},large:{span:6,before:-1}},{direction:props.theme.direction,reverse:true})}
	position: relative;
	z-index: 2;

	${mediaQuery[SIZE.medium]}{
		top: ${unit(8)};
	}

	${mediaQuery[SIZE.large]}{
		top: ${spacer(2)};
	}
`

export const ContentInner = styled.div`
	position: relative;
	background-color: ${props => props.theme.background};
	color: ${props => props.theme.foreground};
	display: flex;

	margin-left: ${margin(SIZE.small,{multiplier:-1})};
	padding-left: ${margin(SIZE.small)};
	padding-right: ${margin(SIZE.small)};

	@media (orientation: landscape) {
		min-height: calc(100vh - ${pixelate(spacer(2,{pixelate:false}) + unit(9,{pixelate:false}))});
	}

	${mediaQuery[SIZE.medium]}{
		margin-left: 0;
		margin-right: ${margin(SIZE.medium,{multiplier:-1})};
		padding-right: ${spacer(1)};
		padding-left: ${spacer(1)};
		
	}

	${mediaQuery[SIZE.large]}{
		margin-right: ${margin(SIZE.large,{multiplier:-1})};
		padding-right: ${margin(SIZE.large)};
		padding-left: 0;
	}

	${mediaQuery[SIZE.xlarge]}{
		margin-right: ${margin(SIZE.xlarge,{multiplier:-1})};
		padding-right: ${margin(SIZE.xlarge)};
		// padding-left: ${margin(SIZE.xlarge)};
	}

	${mediaQuery[SIZE.max]}{
		margin-right: ${margin(SIZE.max,{multiplier:-1})};
		padding-right: ${margin(SIZE.max)};
		// padding-left: ${margin(SIZE.max)};
	}
`

export const TextContainer = styled.div`
	${row({large:true})}
	display: flex;
	flex: 0 0 100%;
`

export const TextInner = styled.div`
	${props => column({large:{span:5,total:6,before:1}},{direction:props.theme.direction})}
`

export const TextContent = styled.div`
	padding-top: ${unit(8)};
	padding-bottom: ${unit(8)};
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;

	${mediaQuery[SIZE.large]}{
		padding-top: ${spacer(3)};
		padding-bottom: ${spacer(3)};

	}
`

export const Label = styled.p`
	${typeLabel01}
	color: ${props => props.theme.foreground};
	margin-bottom: ${unit(3)};
`

export const Heading = styled.div`
	${typeHeading01}
`

export const Text = styled.div`
	${typeBody02}
	margin-top: ${unit(3)};
`

export const Buttons = styled(StyledButtons)`
	margin-top: ${unit(5)};
	align-items: flex-start;
`